import React from 'react';
import InlineSVG, { Props as InlineSVGProps } from 'react-inlinesvg';

export type SVGAssetProps =
    & InlineSVGProps
    & {
    ['aria-label']?: string
    width?: number
};

/**
 * Renders an svg asset based on a list of preset types.
 * This will asynchronously inline the SVG into the DOM,
 * using library 'react-inlinesvg'.
 */
export const SVGAsset = ({
    width = 20, ...restProps
}: SVGAssetProps) => {
    return (
        <InlineSVG
            role={'img'}
            {...restProps}
            width={width}
        />
    );
};
